import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraEntityCell } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useCapabilityProofs } from './hooks';
import { proofKindLabel } from './proofKinds';
// Summary refs have titles but no proof kind. Read the viewer's proof receipt
// only for the single-proof case, where the second line needs its kind.
export function CapabilityProofSummary({ summary }) {
    const first = summary?.proof[0];
    const proof = useCapabilityProofs(first && summary?.proofCount === 1 ? summary.capabilityId : '');
    const kind = proof.data?.proofs.find((p)=>p.artifactId === first?.id)?.proofKind;
    return /*#__PURE__*/ _jsx("span", {
        "data-testid": Testids.registryCapabilities.proofCell,
        children: first ? /*#__PURE__*/ _jsx(SpecraEntityCell, {
            title: first.name,
            description: summary && summary.proofCount > 1 ? `+${summary.proofCount - 1} more` : kind ? proofKindLabel(kind) : undefined
        }) : '—'
    });
}
